import React, { useContext, useState, useEffect, useRef } from 'react'
import { Event } from './event'
import { DashboardContext } from '../../../context/DashboardContext'
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel'
// import NoEvents from '../../../assets/no_upcoming_events.png'

export function EventsWrap() {
  const { upcomingMeetings, eventsLoading } = useContext(DashboardContext)
  const containerRef = useRef(null)
  const [cardsPerRow, setCardsPerRow] = useState(3)
  const CARD_WIDTH = 287 // Width of each card
  const CARD_GAP = 36 // gap-9 = 36px
  const ARROW_PADDING = 24 // Padding for the navigation arrows

  useEffect(() => {
    const calculateCardsPerRow = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth
        const possibleCards = Math.floor((containerWidth + CARD_GAP) / (CARD_WIDTH + CARD_GAP))
        setCardsPerRow(Math.max(1, Math.min(4, possibleCards))) // Limit to max 4 cards per row
      }
    }

    // Initial calculation
    calculateCardsPerRow()

    // Recalculate on window resize
    const handleResize = () => {
      calculateCardsPerRow()
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const MEETINGS_PER_PAGE = cardsPerRow * 2 // 2 rows
  const totalPages = Math.ceil(upcomingMeetings.length / MEETINGS_PER_PAGE)

  // Calculate the exact width needed for the cards plus padding for arrows
  const contentWidth = cardsPerRow * CARD_WIDTH + (cardsPerRow - 1) * CARD_GAP + ARROW_PADDING

  return (
    <div className="mt-6 mb-8">
      {!eventsLoading && upcomingMeetings.length > 0 && (
        <>
          <p className="text-[#62708d] text-lg font-bold font-['Manrope'] leading-tight tracking-wide mb-3">
            Upcoming Meetings
          </p>
          <div className="relative" ref={containerRef}>
            <div style={{ width: `${contentWidth}px` }} className="relative">
              <Carousel
                opts={{
                  align: 'start',
                }}
                className="w-full"
              >
                <CarouselContent className="-ml-0">
                  {Array.from({ length: totalPages }).map((_, index) => (
                    <CarouselItem key={index} className="basis-full pl-0">
                      <div className="flex flex-wrap gap-x-9 gap-y-4 pr-6">
                        {upcomingMeetings
                          .slice(index * MEETINGS_PER_PAGE, (index + 1) * MEETINGS_PER_PAGE)
                          .map((event) => (
                            <Event key={event.id} event={event} />
                          ))}
                      </div>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                {totalPages > 1 && (
                  <>
                    <CarouselPrevious className="absolute -left-4 top-1/2 transform -translate-y-1/2" />
                    <CarouselNext className="absolute -right-4 top-1/2 transform -translate-y-1/2" />
                  </>
                )}
              </Carousel>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
